import React, { useEffect, createElement } from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { ContactSection } from '../components/ContactSection';
import { motion } from 'framer-motion';
import { Trophy, Zap, Users, Target, Award, TrendingUp, Clock, MapPin, GraduationCap, Dumbbell } from 'lucide-react';
import { Button } from '../components/ui/Button';
const trainingPrograms = [{
  icon: GraduationCap,
  title: 'הדרכה אישית',
  description: 'ליווי אישי צמוד למי שרוצה להשתפר בחתירה ספורטיבית',
  features: ['תוכנית אימונים אישית מותאמת', 'שיפור טכניקה ומהירות', 'תזונה וכושר כללי']
}, {
  icon: Dumbbell,
  title: 'אימוני כוח וסבולת',
  description: 'תוכנית אימונים משלימה לשיפור ביצועים',
  features: ['אימוני אינטרוולים במים', 'תרגילי כוח ליבה ויציבות', 'אימוני סבולת למרחקים ארוכים', 'שיפור מהירות ספרינט']
}];
const benefits = [{
  icon: Zap,
  title: 'שיפור ביצועים',
  description: 'אימוני מהירות וסבולת ממוקדים לשיפור כושר וטכניקה'
}, {
  icon: Users,
  title: 'קהילת חותרים ספורטיבית',
  description: 'הצטרפו לקהילת חותרים המחויבים להשתפר'
}, {
  icon: Award,
  title: 'חתירה ברמה גבוהה',
  description: 'ליווי מקצועי לחתירה ספורטיבית ואיכותית'
}, {
  icon: Target,
  title: 'מעקב אישי',
  description: 'תוכנית אימונים אישית ומעקב אחר התקדמות'
}];
export function SUPRacePage() {
  useEffect(() => {
    // Set meta tags for SUP Race page
    document.title = "SUP Race - חתירה ספורטיבית | ביץ' קלאב מעגן";
    // Update or create meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', 'המועדון היחידי בישראל עם קבוצת חתירה ספורטיבית ייעודית - SUP Race בכנרת. אימונים, הדרכות וציוד מקצועי');
    // Open Graph tags with image
    const ogTags = [{
      property: 'og:title',
      content: "SUP Race - חתירה ספורטיבית | ביץ' קלאב מעגן"
    }, {
      property: 'og:description',
      content: 'המועדון היחידי בישראל עם קבוצת חתירה ספורטיבית ייעודית - אימונים והדרכות SUP Race'
    }, {
      property: 'og:type',
      content: 'website'
    }, {
      property: 'og:image',
      content: 'https://uploadthingy.s3.us-west-1.amazonaws.com/7FYEnEHxXy4Ajs6r7s98nx/939A4238.jpg'
    }, {
      property: 'og:image:width',
      content: '1200'
    }, {
      property: 'og:image:height',
      content: '630'
    }, {
      property: 'og:url',
      content: window.location.href
    },
    // Twitter Card tags
    {
      property: 'twitter:card',
      content: 'summary_large_image'
    }, {
      property: 'twitter:title',
      content: "SUP Race - חתירה ספורטיבית | ביץ' קלאב מעגן"
    }, {
      property: 'twitter:description',
      content: 'המועדון היחידי בישראל עם קבוצת חתירה ספורטיבית ייעודית'
    }, {
      property: 'twitter:image',
      content: 'https://uploadthingy.s3.us-west-1.amazonaws.com/7FYEnEHxXy4Ajs6r7s98nx/939A4238.jpg'
    }];
    ogTags.forEach(tag => {
      let metaTag = document.querySelector(`meta[property="${tag.property}"]`);
      if (!metaTag) {
        metaTag = document.createElement('meta');
        metaTag.setAttribute('property', tag.property);
        document.head.appendChild(metaTag);
      }
      metaTag.setAttribute('content', tag.content);
    });
  }, []);
  return <div className="min-h-screen bg-white" dir="rtl" data-id="element-1861" data-mp="9ofxk239rp4o">
      <Navigation data-id="element-1862" data-mp="eo2d4i6klhgn" />

      {/* Hero Section */}
      <div className="relative h-[70vh] overflow-hidden" data-id="element-1863" data-mp="jg26tsw1re4s">
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-[#0A5F8F]/90 z-10" data-id="element-1864" data-mp="jglrhhd30gmi" />
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/7FYEnEHxXy4Ajs6r7s98nx/939A4238.jpg" alt="SUP Race" className="w-full h-full object-cover" data-id="element-1865" data-mp="ngvuqm9hosxo" />
        <div className="absolute inset-0 z-20 flex flex-col items-center justify-center text-center text-white px-4" data-id="element-1866" data-mp="xf1x14z7k132">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} data-id="element-1867" data-mp="jrtestgh0jbo">
            <Trophy className="w-20 h-20 mx-auto mb-6 text-yellow-400" data-id="element-1868" data-mp="thw70rfrpt8y" />
            <h1 className="text-5xl md:text-7xl font-bold mb-4" data-id="element-1869" data-mp="ok4blnfwzp00">SUP Race</h1>
            <p className="text-xl md:text-2xl max-w-3xl font-light mb-6" data-id="element-1870" data-mp="om74qgcd5y8y">
              המועדון היחידי בישראל עם קבוצה ייעודית לחתירה ספורטיבית
            </p>
            <div className="flex items-center justify-center gap-2 text-yellow-400 font-bold text-lg" data-id="element-1871" data-mp="3s1uwpnvq23c5">
              <Award className="w-6 h-6" data-id="element-1872" data-mp="au0zhpar1boa" />
              <span data-id="element-1873" data-mp="5tcyqbwpxggv">אימונים והדרכות לכל מי שרוצה להשתפר</span>
            </div>
          </motion.div>
        </div>
      </div>

      {/* What is SUP Race Section */}
      <div className="container mx-auto px-4 py-20" data-id="element-1874" data-mp="1m5s0zodyd721">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-4xl mx-auto text-center mb-20" data-id="element-1875" data-mp="1h91o19xg2rku">
          <h2 className="text-4xl md:text-5xl font-bold text-[#0A5F8F] mb-6" data-id="element-1876" data-mp="1trx7x4ue9sf0">
            מה זה SUP Race?
          </h2>
          <p className="text-xl text-gray-600 leading-relaxed" data-id="element-1877" data-mp="1ft5xptinkqw5">
            SUP Race הוא חתירה ספורטיבית בעמידה על גלשן צר, ארוך ומהיר. הגלשנים
            מיועדים למהירות מקסימלית - ברוחב של 20-28 אינץ' ובאורך אחיד של 14
            פיט. זהו ספורט המדגיש כוח, סבולת, טכניקה ואסטרטגיה.
          </p>
        </motion.div>

        {/* Unique Advantage */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-gradient-to-br from-yellow-50 to-orange-50 rounded-3xl p-12 mb-20 border-2 border-yellow-200" data-id="element-1878" data-mp="1yqqo5512fxiv">
          <div className="flex flex-col md:flex-row items-center gap-8" data-id="element-1879" data-mp="2v83fzu6lhvum">
            <div className="bg-white p-6 rounded-2xl shadow-lg" data-id="element-1880" data-mp="2va7sv1mh2571">
              <Award className="w-16 h-16 text-yellow-500" data-id="element-1881" data-mp="352sh480fdo6j" />
            </div>
            <div className="flex-1 text-center md:text-right" data-id="element-1882" data-mp="3128kd5jrkmkx">
              <h3 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-1883" data-mp="310nqli59x7o4">
                המועדון היחידי בישראל עם קבוצת חתירה ספורטיבית ייעודית
              </h3>
              <p className="text-lg text-gray-700 leading-relaxed" data-id="element-1884" data-mp="2r3j1pak1my3m">
                אנחנו גאים להיות המועדון הראשון והיחיד בישראל שמציע קבוצת אימון
                ייעודית לחתירה ספורטיבית. עם מאמנים מוסמכים, ציוד מקצועי,
                ותוכנית אימונים מובנית - מתאים לכל מי שרוצה להשתפר ולחתור ברמה
                גבוהה יותר, ולמי שמעוניין גם להתחרות.
              </p>
            </div>
          </div>
        </motion.div>

        {/* Training Programs Section */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-20" data-id="element-1885" data-mp="23f9i8faaymfn">
          <h2 className="text-4xl md:text-5xl font-bold text-[#0A5F8F] mb-4 text-center" data-id="element-1886" data-mp="1obymarq8puvf">
            אימונים והדרכות
          </h2>
          <p className="text-xl text-gray-600 text-center mb-12 max-w-2xl mx-auto" data-id="element-1887" data-mp="1t9i1puyocdoy">
            תוכניות אימון מקצועיות והדרכה אישית לכל מי שרוצה להשתפר
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12 max-w-4xl mx-auto" data-id="element-1888" data-mp="238pheosvskf8">
            {trainingPrograms.map((program, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.15
          }} className="bg-gradient-to-br from-blue-50 to-cyan-50 p-8 rounded-2xl border border-blue-100" data-id="element-1889" data-mp="15mjnl3y11hu7" data-mpi={index}>
                <div className="bg-white w-16 h-16 rounded-2xl flex items-center justify-center mb-6 shadow-md" data-id="element-1890" data-mp="mv8x2nw7r72u">
                  <program.icon className="w-8 h-8 text-[#0A5F8F]" data-id="element-1891" data-mp="rssdnugdvvxy" />
                </div>

                <h3 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-1892" data-mp="25zilgctca5cf">
                  {program.title}
                </h3>

                <p className="text-gray-600 mb-6 leading-relaxed" data-id="element-1893" data-mp="2209q53inhzer">
                  {program.description}
                </p>

                <ul className="space-y-2" data-id="element-1894" data-mp="2fw3q2x1g5efq">
                  {program.features.map((feature, i) => <li key={i} className="flex items-start gap-2 text-gray-700" data-id="element-1895" data-mp="2ay286ffrbl5u" data-mpi={i}>
                      <div className="w-1.5 h-1.5 rounded-full bg-[#0A5F8F] mt-2" data-id="element-1896" data-mp="2oxtpoq5hfjol" />
                      <span className="text-sm" data-id="element-1897" data-mp="2kwi0umufn2hg">{feature}</span>
                    </li>)}
                </ul>
              </motion.div>)}
          </div>
        </motion.div>

        {/* Race Group - Single Group */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-20" data-id="element-1898" data-mp="2tr62m30su21i">
          <h2 className="text-4xl md:text-5xl font-bold text-[#0A5F8F] mb-4 text-center" data-id="element-1899" data-mp="33p3ud0hvagyv">
            הקבוצה שלנו
          </h2>
          <p className="text-xl text-gray-600 text-center mb-12 max-w-2xl mx-auto" data-id="element-1900" data-mp="3nam66rfo6f3u">
            קבוצת אימון אחת לכל הרמות, עם אימונים מותאמים אישית
          </p>

          <div className="max-w-2xl mx-auto" data-id="element-1901" data-mp="3dalhepz176s9">
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="bg-white rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-300" data-id="element-1902" data-mp="3de0x9v0j4juq">
              <div className="h-2 bg-gradient-to-r from-blue-500 to-cyan-400" data-id="element-1903" data-mp="2ul5gi1jfpcbb" />

              <div className="p-8" data-id="element-1904" data-mp="2uj2h4qwe66tx">
                <div className="bg-gradient-to-br from-gray-50 to-gray-100 w-16 h-16 rounded-2xl flex items-center justify-center mb-6 mx-auto" data-id="element-1905" data-mp="2zjqh422lly0a">
                  <Trophy className="w-8 h-8 text-[#0A5F8F]" data-id="element-1906" data-mp="2knr9stnbc1w7" />
                </div>

                <h3 className="text-2xl font-bold text-gray-900 mb-2 text-center" data-id="element-1907" data-mp="2pkr7oha0dyc8">
                  קבוצת חתירה ספורטיבית
                </h3>
                <div className="inline-block px-3 py-1 rounded-full text-sm font-bold mb-4 bg-gradient-to-r from-blue-500 to-cyan-400 text-white mx-auto block w-fit" data-id="element-1908" data-mp="2t0vw5q7kqdx4">
                  All Levels
                </div>

                <p className="text-gray-600 mb-6 leading-relaxed text-center" data-id="element-1909" data-mp="2j26cbrw4aje8">
                  קבוצה אחת המאחדת חותרים בכל הרמות - ממתחילים ועד מתקדמים. כל
                  חותר מקבל תוכנית אימונים אישית המותאמת לרמתו ויעדיו האישיים.
                  הדגש הוא על שיפור מתמיד וחתירה ספורטיבית ברמה גבוהה.
                </p>

                <div className="flex items-center justify-center gap-2 text-gray-700" data-id="element-1910" data-mp="2x1pk2jl0nsq0">
                  <Clock className="w-5 h-5 text-[#0A5F8F]" data-id="element-1911" data-mp="320iolmibs9e1" />
                  <span className="font-semibold text-lg" data-id="element-1912" data-mp="3pr4y7i7za1q5">
                    3-4 אימונים בשבוע
                  </span>
                </div>
              </div>
            </motion.div>
          </div>
        </motion.div>

        {/* Benefits Section */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-20" data-id="element-1913" data-mp="1j1bb83ti0eum">
          <h2 className="text-4xl md:text-5xl font-bold text-[#0A5F8F] mb-12 text-center" data-id="element-1914" data-mp="1sre320ovvmrd">
            למה להצטרף לקבוצה שלנו?
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-1915" data-mp="1nvysbhm6a6z6">
            {benefits.map((benefit, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: index % 2 === 0 ? -30 : 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex gap-6 p-6 bg-gradient-to-br from-blue-50 to-cyan-50 rounded-2xl border border-blue-100" data-id="element-1916" data-mp="105uwvxj51dj9" data-mpi={index}>
                <div className="bg-white p-4 rounded-xl shadow-sm h-fit" data-id="element-1917" data-mp="2gi9z5a0dh44f">
                  <benefit.icon className="w-8 h-8 text-[#0A5F8F]" data-id="element-1918" data-mp="2gkcodrtpat83" />
                </div>
                <div data-id="element-1919" data-mp="1d74e3rtqgd1p">
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-1920" data-mp="1i6gxg2leb1zj">
                    {benefit.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed" data-id="element-1921" data-mp="1n5abpx8iax0r">
                    {benefit.description}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </motion.div>

        {/* Equipment Section */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-gray-50 rounded-3xl p-12 mb-20" data-id="element-1922" data-mp="uipisscducv3">
          <h2 className="text-3xl font-bold text-[#0A5F8F] mb-6 text-center" data-id="element-1923" data-mp="13fq8r3f3oj0n">
            הציוד שלנו
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-1924" data-mp="bqmz184g2ggm">
            <div data-id="element-1925" data-mp="boamxbldb0bh">
              <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-1926" data-mp="fryuhua01vwq">
                גלשני RACE מקצועיים
              </h3>
              <ul className="space-y-3 text-gray-700" data-id="element-1927" data-mp="88zapnimm2cu">
                <li className="flex items-start gap-2" data-id="element-1928" data-mp="86d3jozndov5">
                  <div className="w-2 h-2 rounded-full bg-[#0A5F8F] mt-2" data-id="element-1929" data-mp="3afnljsaqkiw" />
                  <span data-id="element-1930" data-mp="3vcx4urx5kz5t">גלשנים צרים ומהירים ברוחב 20-28 אינץ'</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-1931" data-mp="3qe2hrds5kofw">
                  <div className="w-2 h-2 rounded-full bg-[#0A5F8F] mt-2" data-id="element-1932" data-mp="3qdkdbtvc73ww" />
                  <span data-id="element-1933" data-mp="3lg11f0m43384">אורך אחיד של 14 פיט לכל הגלשנים</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-1934" data-mp="3gnr3oyer8yva">
                  <div className="w-2 h-2 rounded-full bg-[#0A5F8F] mt-2" data-id="element-1935" data-mp="3gm6b3ec03q02" />
                  <span data-id="element-1936" data-mp="3bpplsgt2f5le">ציוד מקצועי לחתירה ספורטיבית</span>
                </li>
              </ul>
            </div>
            <div data-id="element-1937" data-mp="37pfgl6d3kj7l">
              <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-1938" data-mp="37lrn277njwsv">
                משוטים מקצועיים
              </h3>
              <ul className="space-y-3 text-gray-700" data-id="element-1939" data-mp="2xpoo1a83kea5">
                <li className="flex items-start gap-2" data-id="element-1940" data-mp="2xq6pqmdj3kpg">
                  <div className="w-2 h-2 rounded-full bg-[#0A5F8F] mt-2" data-id="element-1941" data-mp="11m0by63ycvie" />
                  <span data-id="element-1942" data-mp="16ld7df8w3awl">משוטי קרבון קלים ויעילים</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-1943" data-mp="16nfwlx27x009">
                  <div className="w-2 h-2 rounded-full bg-[#0A5F8F] mt-2" data-id="element-1944" data-mp="rvfhmuvbad5a" />
                  <span data-id="element-1945" data-mp="wva50ofvokll">ציוד איכותי לחתירה מקצועית</span>
                </li>
              </ul>
            </div>
          </div>
        </motion.div>

        {/* CTA Section */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-gradient-to-br from-[#0A5F8F] to-[#0D7AB8] rounded-3xl p-12 text-center text-white relative overflow-hidden" data-id="element-1946" data-mp="iy54t52uify9">
          <div className="absolute inset-0 opacity-10" data-id="element-1947" data-mp="dyirywqxj1pz">
            <div className="absolute inset-0" style={{
            backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
            backgroundSize: '40px 40px'
          }} data-id="element-1948" data-mp="23cxcf4ux02fo" />
          </div>

          <div className="relative z-10" data-id="element-1949" data-mp="3st107m22eefj">
            <Trophy className="w-16 h-16 mx-auto mb-6 text-yellow-400" data-id="element-1950" data-mp="3ntwsz0ypaqru" />
            <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-1951" data-mp="3nrk3m2qm5e4r">
              מוכנים להצטרף לקבוצה?
            </h2>
            <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto" data-id="element-1952" data-mp="1mgaq6rnrekm">
              בואו לאימון ניסיון חינם ותגלו את החתירה הספורטיבית
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-1953" data-mp="fca14tita6wg">
              <Button size="lg" className="bg-white text-[#0A5F8F] hover:bg-blue-50 font-bold" onClick={() => document.getElementById('contact')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-1954" data-mp="adqfku84qx4m">
                <span className="text-[#0A5F8F]" data-id="element-1955" data-mp="ke9627u79bvi">הצטרפו אלינו עכשיו</span>
              </Button>
              <Button size="lg" variant="outline" className="border-white text-white hover:bg-white/10" data-id="element-1956" data-mp="2r47123hpgn2a">
                <a href="tel:0522632784" className="flex items-center gap-2" data-id="element-1957" data-mp="2m5vq1pfoc6ih">
                  התקשרו: 052-2632784
                </a>
              </Button>
            </div>
          </div>
        </motion.div>
      </div>

      <ContactSection data-id="element-1958" data-mp="3fw4k5kfs37lr" />
      <Footer data-id="element-1959" data-mp="3kt4sk203omg1" />
    </div>;
}